import _ from 'lodash';
import classnames from 'classnames';
import React from 'react';
import PropTypes from 'prop-types';

import Avatar from './avatar';
import HtmlToText from 'html-to-text';

const ProfileAvatar = ({
  className,
  channel,
  convoBackground,
  isLarge,
  isXLarge,
  noWrapper,
  profile,
  wrapperClassName,
  ...props
}) => {
  let outerClassName = classnames('profileAvatar', wrapperClassName, {
    'profileAvatar-iconWrapper': !isLarge && !noWrapper,
    'profileAvatar-iconWrapper-large': isLarge && !isXLarge,
    'profileAvatar-iconWrapper-xlarge': isXLarge,
    'profileAvatar-iconWrapper-convoBackground': convoBackground,
  });

  return (
    <div className={outerClassName} {...props}>
      {renderAvatar()}
    </div>
  );

  function renderAvatar() {
    let imageUrl = profile.image;

    if (channel) {
      return <ChannelIcon channel={channel} isLarge={isLarge} />;
    }

    if (imageUrl) {
      return <Avatar className={className} image={imageUrl} />;
    } else if (profile.name) {
      return <InitialIcon name={profile.name} isLarge={isLarge} isXLarge={isXLarge} />;
    }

    // placeholder profile image
    return <div className="profileAvatar-placeholderIcon" />;
  }
};

ProfileAvatar.propTypes = {
  className: PropTypes.string,
  channel: PropTypes.string,
  convoBackground: PropTypes.bool,
  isLarge: PropTypes.bool,
  isXLarge: PropTypes.bool,
  noWrapper: PropTypes.bool,
  profile: PropTypes.shape({
    image: PropTypes.string,
    name: PropTypes.string,
  }).isRequired,
  wrapperClassName: PropTypes.string,
};

export default ProfileAvatar;

const ChannelIcon = ({ channel, isLarge }) => {
  let channelClass = _.kebabCase(channel);
  let className = classnames('profileAvatar-channelIcon', `profileAvatar-${channelClass}`, {
    'profileAvatar-channelIcon-large': isLarge,
  });
  return <div className={className} />;
};

ChannelIcon.propTypes = {
  channel: PropTypes.string.isRequired,
  isLarge: PropTypes.bool,
};

const InitialIcon = ({ isLarge, isXLarge, name }) => {
  let className = classnames('profileAvatar-initialIcon', {
    'profileAvatar-initialIcon-large': isLarge && !isXLarge,
    'profileAvatar-initialIcon-xlarge': isXLarge,
  });

  let splitName = HtmlToText.fromString(name)
    .trim()
    .split(' ');
  let firstInitial = _.head(splitName)[0];
  let secondInitial = splitName.length > 1 ? _.last(splitName)[0] : '';
  return <div className={className}>{(firstInitial + secondInitial).toUpperCase()}</div>;
};

InitialIcon.propTypes = {
  isLarge: PropTypes.bool,
  isXLarge: PropTypes.bool,
  name: PropTypes.string.isRequired,
};



// WEBPACK FOOTER //
// ./src/scripts/presentation/components/lib/profile_avatar.jsx